// extracted by mini-css-extract-plugin
export default {"container":"_2qGFNcidE507BTXZjpPpEd"};